import { render, staticRenderFns } from "./CrmSalonCarnet.vue?vue&type=template&id=76890738&"
import script from "./CrmSalonCarnet.vue?vue&type=script&lang=js&"
export * from "./CrmSalonCarnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports